import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FramePlaceholderBoundary } from './FramePlaceholderBoundary';
import { QuantityStepper } from '../ui/QuantityStepper';
import { usePrototype } from '../../contexts/PrototypeContext';
import { siteConfig } from '../../data/siteConfig';
import { ProductOffer } from '../ui/ProductOffer';
import { buttonClasses } from '../../utils/buttonStyles';

/**
 * VISUAL PLACEHOLDER — native Website Forge PRODUCT frame output.
 *
 * This is not a production add-to-cart. At integration, render the EXISTING native
 * product frame here and preserve its emitted HTML, actions, field names/IDs, hidden
 * inputs, SKU, quantity and option handling, and price. Native markup/IDs have not been
 * inspected; nothing here asserts compatibility. Prices and fulfillment copy reflect
 * the client's 14 October 2026 reply; native configuration still owns live transactions.
 */
export function WfProductFramePreview() {
  const [qty, setQty] = useState(1);
  const {
    quantity,
    setQuantity,
    campaignName
  } = usePrototype();
  const navigate = useNavigate();
  const {
    product,
    support,
    fulfillment
  } = siteConfig;
  const handleAdd = () => {
    setQuantity(quantity + qty);
    navigate('/cart');
  };
  return <FramePlaceholderBoundary frame="WfProductFramePreview" data-id="element-127" data-mp="3psvpeiaavpsu">
      <div className="flex flex-col" data-id="element-128" data-mp="3ur70ewcc06cn">
        <p className="text-[14px] text-ink-muted" data-id="element-129" data-mp="2ltcnbhk9upo">{product.descriptor}</p>
        <h3 className="mt-2 font-display text-4xl font-medium leading-tight text-ink md:text-5xl" data-id="element-130" data-mp="2ljm9msltljg">{product.name}</h3>
        <p className="mt-4 text-[13px] font-medium text-bronze-deep [overflow-wrap:anywhere]" data-id="element-131" data-mp="7ijr5udpwi8z">{campaignName}</p>
        <div className="mt-3" data-id="element-132" data-mp="haps3tly6a0b"><ProductOffer data-id="element-133" data-mp="hb946tox246f" /></div>
        <p className="mt-3 text-[14px] leading-relaxed text-ink-muted" data-id="element-134" data-mp="h9ei3c1ws60r">{fulfillment.shippingLabel} · {fulfillment.dispatch}</p>

        <p className="mt-6 max-w-md text-[16px] leading-relaxed text-ink-muted" data-id="element-135" data-mp="m7prjloakeig">
          Designed for men and women, with a soft, flexible fit. Use the included handheld controller, or activate voice mode on the mask and say “Hi Mask.”
        </p>

        <dl className="mt-8 border-t border-line" data-id="element-136" data-mp="2ie04k6ktnejg">
          <div className="flex items-center justify-between gap-4 border-b border-line py-4" data-id="element-137" data-mp="2ib452dtbshsw">
            <dt className="text-[14px] text-ink-muted" data-id="element-138" data-mp="2w6g8rapglily">Color</dt>
            <dd className="flex items-center gap-3 text-[15px] font-medium text-ink" data-id="element-139" data-mp="2rcty1o2uvoss">
              <span aria-hidden="true" className="h-5 w-5 rounded-full border border-line-strong bg-surface" data-id="element-140" data-mp="361gniim75wxq" />
              {product.color}
            </dd>
          </div>
          <div className="flex items-center justify-between gap-4 border-b border-line py-3" data-id="element-141" data-mp="3f2xzboskncgm">
            <dt id="product-qty-label" className="text-[14px] text-ink-muted" data-id="element-142" data-mp="3b1vzb5qtywdl">
              Quantity
            </dt>
            <dd data-id="element-143" data-mp="1koexzpjrnf06">
              <QuantityStepper value={qty} onChange={setQty} label="Quantity" data-id="element-144" data-mp="1kpyenh9c3s2h" />
            </dd>
          </div>
        </dl>

        <button type="button" onClick={handleAdd} className={`${buttonClasses('primary', true)} mt-8`} data-id="element-145" data-mp="1gpeh4ckummft">
          Add to Skincare Cart
        </button>

        <p className="mt-5 text-[14px] text-ink-muted" data-id="element-146" data-mp="1alhzkq3oiezq">
          Questions before you order? Call{' '}
          <a href={support.phoneHref} className="font-medium text-ink underline underline-offset-4" data-id="element-147" data-mp="wumyhzzf926p">
            {support.phone}
          </a>
          .
        </p>
      </div>
    </FramePlaceholderBoundary>;
}